import router from './router'
import axios from 'axios'

// http request 拦截器
axios.interceptors.request.use(
  config => {
    if (sessionStorage.getItem('token')) { // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.token = sessionStorage.getItem('token')
    }
    return config
  },
  err => {
    return Promise.reject(err)
  })

// http response 拦截器
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    console.log(error)
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 返回 401 清除token信息并跳转到登录页面
          sessionStorage.removeItem('token')
          router.replace({
            path: '/login'
          })
      }
    }
    return Promise.reject(error.response.data) // 返回接口返回的错误信息
  })

export default axios



// WEBPACK FOOTER //
// ./src/utils/interceptors.js